import GoalApiModel from '@/models/GoalApiModel';
import GoalPageModel from '@/models/GoalPageModel';
import axios from 'axios';

export default class GoalsApiService {
    private baseUrl = window.location.origin;
    getGoal() {
        return axios.get<GoalApiModel>(`${this.baseUrl}/goals/get_goal`);
    }
    setGoal(goalId: number) {
        const config = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
            }
        };
        const params = new URLSearchParams()
        params.append('goal', goalId.toString())
        return axios.post(`${this.baseUrl}/goals/update_goal`, params, config);
    }
    setExperience(experience: number) {
        const config = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
            }
        };
        const params = new URLSearchParams()
        params.append('exp', experience.toString())
        return axios.post(`${this.baseUrl}/goals/update_exp`, params, config);
    }
    getGoalsInfo() {
        return axios.get<GoalPageModel>(`${this.baseUrl}/goals/get_json`);
    }
}